var map = {
	"./ArchiveIcon.png": 2383,
	"./AvgDiscount.png": 7483,
	"./BrockenIcon.png": 1133,
	"./CreateBulk2Icon.png": 3647,
	"./Cuptestimg.png": 5817,
	"./Cuptestimg1.png": 3348,
	"./Defaulticon.png": 6190,
	"./F&G std.png": 4110,
	"./Group.png": 5483,
	"./OrderIcon.png": 509,
	"./PlusIcon.png": 6495,
	"./SalesCycle.png": 186,
	"./Sort.png": 316,
	"./StandardIcon.png": 1796,
	"./Vector.png": 8089,
	"./WowIcon.png": 4592,
	"./X.png": 4682,
	"./allShipment.png": 6997,
	"./approval.png": 5261,
	"./approvedredicon.png": 9331,
	"./backward-icon.png": 4849,
	"./blocker.png": 7344,
	"./business_building.png": 1787,
	"./calendaropssync.png": 6701,
	"./calender_icon.png": 8072,
	"./call.png": 2772,
	"./cancell.png": 8512,
	"./cdrIcon.png": 8652,
	"./check.png": 1034,
	"./clock-icon.png": 4652,
	"./clockhour.png": 1258,
	"./colorpadicon.png": 2647,
	"./comments.png": 1578,
	"./copy-icon.png": 6849,
	"./corporation (1) 1.png": 4887,
	"./damage.png": 9199,
	"./dashboardicon.png": 177,
	"./dashboardiconn.png": 2251,
	"./delivered.png": 3874,
	"./delivery-ops-icon.png": 3377,
	"./delivery_tat.png": 2702,
	"./dispatch-ops-icon.png": 9575,
	"./dispatch_tat.png": 712,
	"./download-icon.png": 9384,
	"./edit_icon.png": 5178,
	"./empty-image.png": 5653,
	"./eyeframe.png": 9598,
	"./f2fmeeting.png": 1217,
	"./fileuploadicon.png": 5254,
	"./fileuploadiconblue.png": 6730,
	"./flag.png": 7546,
	"./flash0nIcon.png": 8613,
	"./fluent_call-16-regular.png": 1884,
	"./forward-icon.png": 6559,
	"./forward.png": 4321,
	"./globe.png": 9465,
	"./hashtagIcon.png": 8749,
	"./imageicon.png": 1290,
	"./inbound.png": 5421,
	"./infoiconmockup.png": 8198,
	"./inventory-ops-icon.png": 7211,
	"./liningicon.png": 1244,
	"./logo-without-bg.png": 3640,
	"./logo.png": 3153,
	"./man 1.png": 515,
	"./mdi_email-outline.png": 4166,
	"./msg-icon.png": 6295,
	"./msgboxblue.png": 6286,
	"./newShipment.png": 8018,
	"./notesIcon.png": 4330,
	"./order-progress-icon.png": 224,
	"./outbound.png": 1960,
	"./outofdel.png": 8542,
	"./outward.png": 4024,
	"./packaging-ops-icon.png": 7228,
	"./packagingopsCompleteIcon.png": 645,
	"./partner_dashboard_all_shipment.png": 1392,
	"./partner_dashboard_delivered.png": 7536,
	"./partner_dashboard_newshipment.png": 1264,
	"./partner_dashboard_pending.png": 2845,
	"./partner_dashboard_shipped.png": 9309,
	"./pencil_uderline.png": 7832,
	"./pending.png": 9163,
	"./percentIcon.png": 4362,
	"./person_icon.png": 3623,
	"./personicon.png": 2492,
	"./playbtn.png": 1436,
	"./pricetagicon.png": 6610,
	"./printer.png": 9698,
	"./printinward.png": 9216,
	"./printinwardblueicon.png": 6327,
	"./prntoutwardicon.png": 3679,
	"./productIcon.png": 2264,
	"./profile.png": 7653,
	"./qualityrejection1blueicon.png": 6420,
	"./qualityrejectionblueicon.png": 975,
	"./rawinward.png": 6883,
	"./rawinwardblueicon.png": 6692,
	"./rawqc.png": 3252,
	"./readytoship.png": 5514,
	"./received_supply_tat.png": 5209,
	"./reject.png": 6285,
	"./reloadicon.png": 7544,
	"./returned.png": 2453,
	"./returnedreq.png": 525,
	"./revenue.png": 750,
	"./rupeeicon.png": 3278,
	"./searchIcon.png": 3907,
	"./select-all.png": 1430,
	"./send-nps-icon.png": 3904,
	"./setting.png": 174,
	"./shipped.png": 3299,
	"./sortDown.png": 4716,
	"./sortUp.png": 1571,
	"./sourcing-ops-icon.png": 9663,
	"./sourcingIcon.png": 8441,
	"./startIcon.png": 5541,
	"./stopIcon.png": 6751,
	"./sucessicon.png": 6217,
	"./swagstore/bag-icon.png": 9416,
	"./swagstore/catalogue.png": 6837,
	"./swagstore/connect-wire.png": 7524,
	"./swagstore/exit-icon.png": 7260,
	"./swagstore/grid-icon.png": 7736,
	"./swagstore/image-icon.png": 7511,
	"./swagstore/my_inventory.png": 8951,
	"./swagstore/navigate-icon.png": 4547,
	"./swagstore/pallette-icon.png": 8573,
	"./swagstore/product-image-fallback.png": 3888,
	"./swagstore/upload_csvtemplate.png": 9444,
	"./total_revenue.png": 4557,
	"./unavailable.png": 9748,
	"./upload.png": 555,
	"./uploadimg.png": 7942,
	"./vendoricon.png": 1849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3096;